import { readFile } from "fs/promises";
import "path";
import { p as passMatrixBuild } from "../../../../../chunks/utils.js";
const prerender = false;
const filePath = "src/_games.json";
const eventsFor = (event, playerid, events) => Object.values(events ?? {})?.filter(
  (v, i, l) => v.type == event && (v.to == playerid || v.from == playerid || v.fromTeam == playerid)
  // ||
  // v.toTeam == playerid
);
async function load({ fetch, params }) {
  const data = JSON.parse(await readFile(filePath, "utf8"))[params.id];
  const homepasses = passMatrixBuild(data, "home");
  const awaypasses = passMatrixBuild(data, "away");
  const homelineup = JSON.parse(
    await readFile(filePath, "utf8")
  )[params.id]?.home_lineup ?? // (await read(filePath).json())[params.id]?.home_lineup ??
  await (await fetch(
    `https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/games/${params.id || ""}/home_lineup.json`
  )).json();
  const awaylineup = JSON.parse(await readFile(filePath, "utf8"))[params.id]?.away_lineup ?? // (await read(filePath).json())[params.id]?.away_lineup ??
  await (await fetch(
    `https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/games/${params.id || ""}/away_lineup.json`
  )).json() ?? {};
  const events = JSON.parse(await readFile(filePath, "utf8"))[params.id]?.events ?? // (await read(filePath).json())[params.id]?.events ??
  await (await fetch(
    `https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/games/${params.id || ""}/events.json`
  )).json();
  const homeplayerstats = Object.keys(homelineup ?? {}).map(
    (playerid, i, l) => {
      return {
        // profile
        ...homelineup[playerid],
        id: playerid,
        name: homelineup[playerid]?.name,
        passes: (
          // ?.filter(
          //   (v, i, l) => v.from == playerid
          // )
          eventsFor("pass", playerid, events)?.length
        ),
        lostballs: eventsFor("lost-ball", playerid, events)?.filter(
          (v, i2, l2) => v.from == playerid && awaylineup[v.to]?.role != "goalkeeper"
        )?.length + eventsFor("pass", playerid, events)?.filter(
          (v, i2, l2) => v.from == playerid && awaylineup[v.to] != void 0 && awaylineup[v.to]?.role != "goalkeeper"
        )?.length,
        tackles: eventsFor("lost-ball", playerid, events)?.filter(
          (v, i2, l2) => v.to == playerid
        )?.length + eventsFor("pass", playerid, events)?.filter(
          (v, i2, l2) => v.to == playerid && awaylineup[v.from] != void 0
        )?.length
      };
    }
  );
  return {
    id: params.id,
    homeplayerstats: homeplayerstats.filter((v, i, l) => v.passes > 0),
    // passes: dt[0],
    // lineup: Array.from(dt[1]),
    // passes: matrix,
    passes: awaypasses.passes,
    // lineup: colNames,
    lineup: awaypasses.lineup,
    // rowNames: rowNames,
    rowNames: awaypasses.rowNames,
    colNames: awaypasses.colNames,
    playerRoles: awaypasses.playerRoles,
    //dt[2],
    // passes: homepasses.passes,
    // // lineup: colNames,
    // lineup: homepasses.lineup,
    // // rowNames: rowNames,
    // rowNames: homepasses.rowNames,
    // colNames: homepasses.colNames,
    // playerRoles: homepasses.playerRoles, //dt[2],
    homepasses,
    awaypasses
  };
}
export {
  load,
  prerender
};
